import { format } from "date-fns-jalali";
import { faIR } from "date-fns-jalali/locale";

const isValidDate = (date: unknown): date is Date =>
  date instanceof Date && !isNaN(date.getTime());

const formatPersianDate = (date: Date, fromat?: string) => {
  const safeDate = isValidDate(date) ? date : new Date();
  return format(safeDate, fromat || "dd MMMM", { locale: faIR });
};

export default formatPersianDate;
